<nv-icon-button [name]="icon" [isInverted]="isInverted" (clickButton)="goBack()"></nv-icon-button>